import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/esm/extends";
var _Skeleton;
import * as React from 'react';
import { Chip, Skeleton } from '@lumahealthhq/ui-core';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ChipAvailability(_ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  // eslint-disable-next-line formatjs/no-literal-string-in-jsx
  return /*#__PURE__*/_jsx(Chip, _extends({
    variant: "outlined",
    disabled: true,
    label: _Skeleton || (_Skeleton = /*#__PURE__*/_jsx(Skeleton, {
      width: "50px"
    }))
  }, rest));
}